import { Pipe, PipeTransform } from '@angular/core';
import { ContentContextType } from '@shared/enums/ContentContextType';
import { ContentMediaType } from '@shared/enums/ContentMediaType';
import { IContentModel } from '@shared/models/content.model';

@Pipe({
    name: 'filterContentUrl'
})
export class FilterContentUrlPipe implements PipeTransform {
    transform(contents: IContentModel[], language: string, contextType?: ContentContextType, mediaType?: ContentMediaType): any {
        let value = null;

        if (contextType && mediaType) {
            value = contents?.find(x => x.languageId === language && x.contentContextType === contextType && x.contentMediaType === mediaType)?.url;
        } else if (contextType) {
            value = contents?.find(x => x.languageId === language && x.contentContextType === contextType)?.url;
        } else {
            value = contents?.find(x => x.languageId === language)?.url;
        }

        return value;
    }
}
